module.exports = __webpack_public_path__ + "media/images/application/choose-price/poulpe-03-382893f2efab78df02f34ce77b4c3e65.svg";